import React from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

export class Footer extends React.Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		const route = this.props.route ? `/${this.props.route}` : '/cgu' ;
		this.props.cguData.list = _.sortBy(this.props.cguData.list, 'ordreAffichage');
		const today = new Date();
		const year = today.getFullYear();
		return (
		    <div className="footer">
		      <ul className="list-inline">
		      	{ 
		      		this.props.cguData.list.map(cgu => 
		      		<li className="list-inline-item" key={cgu.id}>
		      			<Link to={`${route}/${cgu.id}`} target="_blank">
		      				<span>{cgu.cguTitle}</span> -  
		      			</Link>
		      		</li> )}
		      	
		      		<li className="list-inline-item"><span>Copyright {year}</span></li>
		      </ul>
		    </div>
		)
	}
}

const mapStateToProps = state => ({
	cguData: state.cguData
})

export default connect(mapStateToProps)(Footer);


// WEBPACK FOOTER //
// ./src/components/Footer.js